import { BaseResponse, request } from "@/lib/request";

export interface AnnouncementResponse {
	announcement_id: string;
	content: string;
	type: string;
	has_read: boolean;
	created_time: number;
	title: string;
}

export const getAnnouncement = async ({
	page_num = 1,
	page_size = 20,
}: {
	page_num: number;
	page_size: number;
}): Promise<
	BaseResponse<{
		list: AnnouncementResponse[];
		total: number;
		has_read: boolean;
	}>
> => {
	return await request.get("/aifk/announcement/list", {
		page_num,
		page_size,
	});
};

export const readAnnouncement = async (
	announcementId: string,
): Promise<BaseResponse<null>> => {
	return await request.post("/aifk/announcement/read", { announcementId });
};
